<script setup lang="ts">
// PROPS
interface Props {
    title: string;
}

const { title } = defineProps<Props>();

// MODEL
const open = defineModel<boolean>('open', { required: true });

// COMPOSABLES
const { isMobile } = useResponsive();
</script>

<template>
    <UModal v-model:open="open" :fullscreen="isMobile" :dismissible="false" :title="title" :close="false" v-bind="modalNoDescAriaFixupProps">
        <template #body>
            <div class="text-center">
                <UIcon name="i-svg-spinners-270-ring" class="text-primary-400 h-8 w-8" />
            </div>
        </template>
    </UModal>
</template>
